export enum CustomWidgetFieldValues {
    ActualValue = 1000,
    // eslint-disable-next-line prettier/prettier
    MinValue,
    MaxValue,
    LabelValue = 3000,
}